export default function statsDemo() {
  window.metrics = undefined;
  const updateStats = () => {
    try {
      // eslint-disable-next-line
      window.metrics = window.__eb.getMetrics()._metrics;
    } catch (TypeError) {
      console.error(TypeError);
    }
  };
  setInterval(() => {
    updateStats();
  }, 500);
}



// WEBPACK FOOTER //
// ./src/js/videoJSExtensions/stats-demo.js